export const ModalMessage = ({ title, children }: { title?: string; children?: JSX.Element }) => {
  return (
    <div className={`flex modal fixed z-50 w-full h-full overflow-x-hidden bg-gray-200 bg-opacity-50 p-8`}>
      <div className="flex flex-col m-auto igray p-2 rounded-lg overflow-y-auto ">{children}</div>
    </div>
  );
};
